// DEPRECATED
define('home/mixins/withReasonOld',[
    'underscore',
    'home/views/ActivityActorsHoverCard',
    'core/utils',
], function (
    _,
    ActivityActorsHoverCard,
    utils
) {
    'use strict';

    var initHoverCard = function () {
        // We don't use upvoter cards on mobile-like user agents.
        if (utils.isMobileUserAgent())
            return;

        var target = this.$('[data-role=actors]');
        if (!target.length)
            return;

        if (this.hoverCard)
            this.hoverCard.remove();

        this.hoverCard = ActivityActorsHoverCard.create({
            targetElement: target,
            activityFeedItem: this.model,
            activityId: this.model.id,

            numShownActors: getShownActors.call(this).length,
        });
    };

    /**
     * Returns an array of just the actors to show in the reason. If the
     * number of actors is 3 or less, shows all of them. Otherwise it
     * shows 2 of them, plus a count of the remaining actors.
     */
    var getShownActors = function () {
        if (!this.model.actors)
            return [];

        if (this.model.get('totalActors') < 4)
            return this.model.toJSON().actors;

        return this.model.toJSON().actors.slice(0, 2);
    };

    /**
     * Returns the number of times this action occurred.
     * For right now, we only show a count if there was only 1 actor
     * and more than 1 occurrence.
     * ex: Nicole commented 2 times
     */
    var getNumOccurrences = function () {
        if (!this.model.actors || this.model.actors.length !== 1)
            return 0;

        var numOccurrences = this.model.get('totalActivities');
        return numOccurrences > 1 ? numOccurrences : 0;
    };

    var withReason = function () {
        this.initialize = _.wrap(this.initialize, function (_initialize) {
            _initialize.apply(this, _.rest(arguments));

            this.listenTo(this, 'render', initHoverCard);
        });

        var _templateHelpers = this.templateHelpers;
        this.templateHelpers = function () {
            var shownActors = getShownActors.call(this);
            return _.extend({
                relativeTime: this.model.getRelativeTimestamp(),
                shownActors: shownActors,
                numRemainingActors: this.model.get('totalActors') - shownActors.length,
                numOccurrences: getNumOccurrences.call(this),
            },
            _templateHelpers ? _templateHelpers.apply(this, arguments) : {});
        };
    };

    return withReason;
});

